<template>
    <div>
        <v-card color="transparent" flat>
            <v-toolbar color="transparent" flat>
                <v-toolbar-title class="font-weight-bold">{{ $t('geneticsAndBreeding.selectAnimal') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined @click="$router.push({ name: 'GeneticsList' })">{{
                    $t('geneticsAndBreeding.cancel') }}</v-btn>
                <v-btn color="primary" class="ml-2" depressed @click="animalSelected" :disabled="selected.length < 1"> {{
                    $t('geneticsAndBreeding.next') }}</v-btn>
            </v-toolbar>
        </v-card>
        <v-card class="pa-4">
            <v-data-table :headers="headers" :items="animals" v-model="selected" show-select item-key="id" single-select
                :items-per-page="10" :loading="loading" loading-text="Loading Animals... Please wait" hide-default-footer
                :options.sync="tableOptions" :server-items-length="totalRecords" :header-props="{
                        'sort-icon': 'mdi-unfold-more-horizontal'
                    }">
                <template v-slot:top>
                    <div class="d-flex mt-5">
                        <v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px"
                            :placeholder="$t('geneticsAndBreeding.searchBy')" dense v-model="search" class="shrink"
                            @input="resetSearchOnEmpty"></v-text-field>
                        <v-btn :disabled="search.length < 1" color="primary" height="40" width="40" max-width="40" outlined
                            class="ml-8" @click="searchEPDAnimal">
                            <v-icon>mdi-filter-outline</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <div class="py-1 title">
                            {{ from }} - {{ to }} of {{ totalRecords }}
                        </div>
                        <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page <= 1"
                            @click="pageChange(false)">
                            <v-icon dark> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page >= totalPages"
                            @click="pageChange(true)">
                            <v-icon dark> mdi-chevron-right </v-icon>
                        </v-btn>
                    </div>
                </template>
                <template v-slot:progress>
                    <v-progress-linear color="primary" :height="8" indeterminate></v-progress-linear>
                </template>
                <template v-slot:item.birthOrigin.dateOfBirth="{ item }">
                    <span>{{ (!item?.birthOrigin?.dateOfBirth || item?.birthOrigin?.dateOfBirth == '0000-00-00') ? '' : new
                        Date(item.birthOrigin.dateOfBirth).toLocaleDateString('en-us') }}</span>
                </template>
                <template v-slot:item.id="{ item }">
                    <span>{{ getAnimalIdWithPad(item.id) }}</span>
                </template>
                <template v-slot:item.animalIdentification.dateOfRegistration="{ item }">
                    <span>{{ (!item?.animalIdentification?.dateOfRegistration ||
                        item?.animalIdentification?.dateOfRegistration == '0000-00-00') ? '' : new
                            Date(item?.animalIdentification?.dateOfRegistration).toLocaleDateString('en-us') }}</span>
                </template>
                <template v-slot:item.tagNumber="{ item }">
                    <span>{{ showTags(item?.animalIdentification?.identificationMethods) }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                    <v-btn style="background: #E5F8F1;" color="#00BD73" outlined rounded>{{ item.status || 'N/A' }}</v-btn>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import gql from "graphql-tag";
export default {
    apollo: {

        animalListing: {
            query: gql`
      query getAnimalsWithoutEpd($search: String!,$limit: Float!,$page: Int!,$userId:Int!) {
        getAnimalsWithoutEpd(search:$search,limit:$limit,page :$page,userId:$userId) {
            count
    totalCount
     rows{
      id
      gender
      animalIdentification{
        livestockName
      }
      birthOrigin{
        dateOfBirth
        conceptionMethod{
            name
        }
      }
      #breedName
      breed{
        name
      }
      animalIdentification{
        dateOfRegistration
      }
      status
      animalIdentification{
        identificationMethods{
          tagColor
        }
      }
      
    }
          }
        }`,
            variables() {
                return {
                    search: this.search,
                    sortCol:"",
                    sortOrder:"",
                    page: this.tableOptions.page,
                    limit: this.tableOptions.itemsPerPage,
                    userId:parseInt(this.$store.getters.getUser.userDetail.id),
                };
            },

            result: function ({ data }) {
                if (data.getAnimalsWithoutEpd) {
                    this.animals = data.getAnimalsWithoutEpd.rows;
                    this.totalRecords = data.getAnimalsWithoutEpd.totalCount;
                    this.totalPages = Math.ceil(
                        this.totalRecords / this.tableOptions.itemsPerPage
                    );
                    this.from =
                        (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
                    this.to =
                        this.tableOptions.page * this.tableOptions.itemsPerPage -
                        (this.tableOptions.itemsPerPage - data.getAnimalsWithoutEpd.count);
                }
            },
            update: (data) => {
                return data.getAnimalsWithoutEpd;
            },
            error: (err) => {
                console.log(err)
            }

        },
    },
    data() {

        return {
            loading: false,
            search: "",
            selected: [],
            totalRecords: 0,
            totalPages: 0,
            to: 0,
            from: 0,
            tableOptions: {
                page:1,
                itemsPerPage:10,
               

            },
            headers: [
                {
                    text: this.$t('geneticsAndBreeding.animalID'),
                    align: "start",
                    value: "id",
                    class: "black--text",
                    sortable: false,
                },
                {
                    text: this.$t('geneticsAndBreeding.tag'),
                    value: "tagNumber",
                    class: "black--text",
                    sortable: false,
                },
                {
                    text: this.$t('geneticsAndBreeding.birthDate'),
                    value: "birthOrigin.dateOfBirth", class: "black--text", sortable: true
                },
                {
                    text: this.$t('geneticsAndBreeding.gender'),
                    value: "gender",
                    class: "black--text",
                    sortable: false,
                },
                {
                    text: this.$t('geneticsAndBreeding.breed'),
                    value: "breed.name",
                    class: "black--text",
                    sortable: false,
                },
                {
                    text: this.$t('geneticsAndBreeding.regDate'),
                    value: "animalIdentification.dateOfRegistration",
                    class: "black--text",
                    sortable: false,
                },
                {
                    text: this.$t('geneticsAndBreeding.status'),
                    value: "status",
                    class: "black--text",
                    sortable: false,
                },
            ],
            animals: [
                {
                    animalId: "dlsjfklds",
                    tag: "sdjklf jsdlfj"
                },
                {
                    animalId: "afsda",
                    tag: "adsa jsdlfj"
                }
            ],
        }
    },
    methods: {
        getData() {

        const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
        const filter = {
            search: this.search,
            //sortBy:this.tableOptions.sortBy,
            //sortDesc:this.tableOptions.sortDesc,
            page: page,
            limit: itemsPerPage,
            userId: this.$store.getters.getUser.id,
        }

   
        if (sortBy.length === 1 && sortDesc.length === 1){
          filter.sortCol = sortBy[0];
          filter.sortOrder = sortDesc[0]? 'DESC' : 'ASC'
        }

        this.filter = filter;
        this.$apollo.queries.animalListing.refetch();
    },
        getAnimalIdWithPad(animalId){
            const animalIdString = animalId.toString();
            let animalIdWithPad = animalIdString.padStart(7, '0');
            return "ANI" + animalIdWithPad;
        },
        showTags(tags) {
            if (tags && tags.length > 0) {
                let tagArray = [];

                for (const tag of tags) {
                    if (tag.tagColor && tag.tagColor != "") {
                        tagArray.push(tag.tagColor);
                    }
                }
                return tagArray.join(', ');
            } else {
                return "";
            }

        },
        animalSelected() {
            this.$emit('animal-selected', this.selected)
        },
       
        pageChange(t) {
            console.log("pageChangepageChange")
            if (t) this.tableOptions.page = this.tableOptions.page + 1;
            else this.tableOptions.page = this.tableOptions.page - 1;

            this.getData();
           // this.$apollo.queries.animalListing.refetch();
        },
        searchEPDAnimal() {
            console.log("searchEPDAnimal")
            if (this.search == "") return;
            this.tableOptions.page = 1;

           

            this.getData();
           // this.$apollo.queries.animalListing.refetch();
        },

        resetSearchOnEmpty() {
            console.log("resetSearchOnEmpty")
            if (this.search !== "") return;
            this.tableOptions.page = 1;
            this.getData();
            //this.$apollo.queries.animalListing.refetch();
        },

    }
}
</script>
<style scoped>
::v-deep .v-data-table-header__icon {
    display: inline-block;
    opacity: 100 !important;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>